
const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user")) || null;
  } catch {
    return null;
  }
};

const initialState = {
    user: getUser(),
};

const adminReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'ADMIN_LOGIN':
            return {
                ...state,
                user: action.payload,
            };
        default:
            return state;
    }
};

export default adminReducer;